
import ReactDOM from 'react-dom/client';
import { useEffect, useState } from "react";
import app from "../components/app";

const loadFonts = function(response) {
  let setFonts = response.styles.map(function(v){
    return v.fontFamily.replace(/ /g,"+");
  }).join(":wght@400;600;700&family=");
  let fontLink = document.querySelector("#googleFonts");
  if(!fontLink) {
    fontLink = document.createElement("link");
    fontLink.setAttribute("rel", "stylesheet");
    fontLink.setAttribute("id", "googleFonts");
    //link.setAttribute("href", file);
    document.head.appendChild(fontLink);
    
  }

  fontLink.setAttribute("href", `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`)
    
}

const sampleStyle = {
  "styleName": "Heading 1",
  "fontFamily": "Open Sans",
  "fontSize": "14",
  "fontSizeWeb": "18",
  "key": "h1"
}

const sampleColor = {
  "styleColorName": "Primary Text Color",
  "styleColor": "#FF000000",
  "key": "ptc"
}



const showPopup = function(id) {
  const ele = document.querySelector("#" + id);
  if(ele.classList.contains("show")) {
      ele.classList.remove("show")
      ele.removeAttribute("style");
  }
  else {
      ele.style.display = "block";
      ele.classList.add("show");
  }
}


const showPopup2 = function(id, data, callback) {
  if(data) {
    const rootEle = document.querySelector(".theme-page");
    const popup = document.createElement("div");
    popup.setAttribute("class", "modal fade");
    popup.setAttribute("id", id);
  
    rootEle.appendChild(popup);
    const root = ReactDOM.createRoot(popup);
    if(id === "textStyleModal") {
      root.render(<StylePopup data={data} callback={callback} />);
    }
    if(id === "colorModal") {
      root.render(<ColorPopup data={data} callback={callback} />);
    }
    
    popup.style.display = "block";
    popup.classList.add("show");
  }
  else {
    document.querySelector("#" + id).remove();
  }
}

const StylePopup = function({data, callback}) {
  const [style, setStyle] = useState(data);
  const updateData = function(event){
    const id = event.currentTarget.getAttribute("id");
    const value = event.currentTarget.value.trim();
    setStyle(prev => ({
      ...prev,
      [id]: value
    }));
  }
  let fonts = [];
  if(localStorage.getItem("fonts")) {
    fonts = JSON.parse(localStorage.getItem("fonts"));
  }
  return <div className="modal-dialog">
  <div className="modal-content rounded-4">
    <div className="modal-header">
      <h5 className="modal-title">Add / Edit Text Style</h5>
      <button type="button" className="btn-close" onClick={() => showPopup2("textStyleModal")} />
    </div>
    <div className="modal-body">
      <div className="bg-light rounded p-3 mb-3 text-center fs-3 fw-bold">{style.styleName}</div>
      <label className="form-label">Style Key</label>
      <input type="text" className="form-control mb-3" id="key" onInput={updateData} value={style.key} />
      <label className="form-label">Style Name</label>
      <input type="text" className="form-control mb-3" id="styleName" onInput={updateData} defaultValue={style.styleName} />
      <label className="form-label">Font Family</label>
      <select className="form-select mb-3" id="fontFamily" onChange={updateData} defaultValue={style.fontFamily}>
        {
          fonts.map(function(v){
            return <option value={v}>{v}</option>
          })
        }
      </select>
     
      <div className="row">
        <div className="col">
          <label className="form-label">Font Size (px)</label>
          <input type="number" className="form-control" id="fontSize" onInput={updateData} defaultValue={style.fontSize} />
        </div>
        <div className="col">
          <label className="form-label">Font Size Web (px)</label>
          <input type="number" className="form-control" id="fontSizeWeb" onInput={updateData} defaultValue={style.fontSizeWeb} />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      <button className="btn btn-light" onClick={() => showPopup2("textStyleModal")}>Cancel</button>
      <button className="btn btn-primary" onClick={() => callback(style)}>Save Changes</button>
    </div>
  </div>
</div>
}

const ColorPopup = function({data, callback}) {
  //colorModal
  const [color, setColor] = useState(data);
  const [tempColor, setTempColor] = useState({
    color:app.getPlanColor(data.styleColor),
    opacity:app.getOpacity(data.styleColor)
  });
  const updateData = function(event){
    const id = event.currentTarget.getAttribute("id");
    const value = event.currentTarget.value.trim();
    if(id === "opacity" || id === "color") {
      let styleColor = app.combineColor(tempColor.color, tempColor.opacity);
      
      if(id === "color") {
        styleColor = app.combineColor(value, tempColor.opacity);
        setTempColor(prev => ({
          ...prev,
          ["color"]: value
        }));
      }
      else {
        styleColor = app.combineColor(tempColor.color, value);
        setTempColor(prev => ({
          ...prev,
          ["opacity"]: value
        }))
      }
      console.log(styleColor);
      setColor(prev => ({
        ...prev,
        ["styleColor"]: styleColor
      }));
    }
    else {
      setColor(prev => ({
        ...prev,
        [id]: value
      }));
    }
  }
  return <div className="modal-dialog">
    <div className="modal-content rounded-4">
      <div className="modal-header">
        <h5 className="modal-title">Add / Update Color</h5>
        <button type="button" className="btn-close" onClick={() => showPopup2("colorModal")} />
      </div>
      <div className="modal-body">
      <label className="form-label">Color Key</label>
      <input type="text" className="form-control mb-3" id="key" onInput={updateData} value={color.key} />
     
        <label className="form-label">Color Name</label>
        <input type="text" className="form-control mb-3" id="styleColorName" placeholder="Enter color name" onInput={updateData} defaultValue={color.styleColorName} />
        <label className="form-label">Color Code</label>
        <div className="input-group">
          <span className="input-group-text">
            <input type="color" className="color-control color-box border" id="color" onChange={updateData} value={tempColor.color}  />
          </span>
          <input type="text" className="form-control" value={color.styleColor} />
          <span className="input-group-text" style={{background:"#f9f9f9"}}>
          <input type="range" className="form-range" id="opacity" min="0" max="100" onChange={updateData} defaultValue={tempColor.opacity} />
          </span>
          <span className="input-group-text" style={{background:"#f9f9f9"}}>
{tempColor.opacity}%
          </span>

         
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" onClick={() => showPopup2("colorModal")}>Cancel</button>
        <button className="btn btn-primary" onClick={() => callback(color)}>Save Changes</button>
      </div>
    </div>
  </div>
}

const Theme = function(props) {
    const [tab, setTab] = useState("typography");
    const [data, setData] = useState(props.data);

    useEffect(() => {
      console.log(data);
      loadFonts(data);
      if(data.id) {
        /*
        if(data.name === "Go Green") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:2,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }
        if(data.name === "Deep Ocean") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:1,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }
        if(data.name === "Cheerful Cherry") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:3,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }

        if(data.name === "Dynamic Sunburst") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:4,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }

        if(data.name === "Carbon Mystique") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:5,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }

        if(data.name === "Techno Grey") {
          fetchData({
            method:"saveTypography",
            
            data:{
            id:data.id,
            themeId:6,
            name:data.name,
            styles:data.styles,
            colors:data.colors
            }
            
          });
        }
        */
       fetchData({
          method:"saveTypography",
          data:{
            id:data.id,
            themeId:data.themeId,
            name:data.name,
            styles:data.styles,
            colors:data.colors
          }
        });
      }
      
      
    }, [data]);

    const saveStyles = function(style, index){

        setData(prev => {
          if(index === undefined) {
            return {
              ...prev,
              styles: [...prev.styles, style]                      
            };
          }
          else {
            const updatedStyles = [...prev.styles];      
            updatedStyles[index] = style;                
        
            return {
              ...prev,
              styles: updatedStyles                      
            };
          }
        });
        showPopup2("textStyleModal");
    }

    const cloneTheme = function(data){

      fetchData({
        method:"saveTypography",
        
        data:{
      //  id:data.id,
        name:"Techno Grey",
        styles:data.styles,
        colors:data.colors
        }
      });
      //window.location.reload();
  }
    
    // const saveStyles = function(style, index){
    //   setData(prev => {
    //     if(index === undefined) {
    //       return {
    //         ...prev,
    //         styles: [...prev.styles, style]                      
    //       };
    //     }
    //     else {
    //       const updatedStyles = [...prev.styles];      
    //       updatedStyles[index] = style;                
      
    //       return {
    //         ...prev,
    //         styles: updatedStyles                      
    //       };
    //     }
    //   });
    // }
    const saveColor = function(color, index){
      setData(prev => {
        if(index === undefined) {
          return {
            ...prev,
            colors: [...prev.colors, color]                      
          };
        }
        else {
          const updatedColors = [...prev.colors];      
          updatedColors[index] = color;                
      
          return {
            ...prev,
            colors: updatedColors                      
          };
        }
      });
      showPopup2("colorModal");
    }

    const deleteTheme = function(){
      if(window.confirm("do you want delete this theme")) {
        fetchData({
          method:"deleteTypography",
          id:data.id
        }).then(function(){
          window.location.reload()
        })
      }
       
        
    }

   
   
    return <div className="card">
  <div className="card-body">
    {/* Tabs */}
    <button className={`btn btn-primary btn-sm float-end`} onClick={() => cloneTheme(data)}>
                    Clone Theme
    </button>
    <button className={`btn btn-primary btn-sm me-2 float-end d-none`} onClick={deleteTheme}>
                    Delete Theme
    </button>
    <ul className="nav nav-tabs mb-4" id="myTab" role="tablist">
      
          {
              ["Typography", "Colors"].map(function(v){
                return <li className="nav-item" key={v}>
                <button className={`nav-link ${v.toLowerCase() === tab?"active":""}`} id="typography-tab" onClick={() => setTab(v.toLowerCase())}>
                    {v}
                </button>
                </li>
              })
          }
    </ul>
    {/* Content */}
    <div className="tab-content" id="myTabContent">
      <div className={`tab-pane fade ${tab === "typography"?"show active":""}`} id="typography" role="tabpanel">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0 fw-bold">Typography Styles</h6>
          <button className="btn btn-primary btn-sm" onClick={() => showPopup2("textStyleModal", JSON.parse(JSON.stringify(sampleStyle)), function(style){
            saveStyles(style);
          })}>+ Add Text Style</button>
        </div>
        {/* Headings List */}
        {
            data.styles.map(function(v, i){
                return    <div className="heading-item" key={`styles${i}`}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="heading-label">{v.styleName} - {v.fontFamily} / {v.fontSizeWeb}px</div>
                    <div className="mb-0" style={{fontFamily:v.fontFamily, fontSize:`${v.fontSizeWeb}px`}}>{v.styleName}</div>
                  </div>
                  <div>
                    <i className="bi bi-pencil mx-2" onClick={() => showPopup2("textStyleModal", v, function(style){
                      saveStyles(style, i);
                    })} />
                    <i className="bi bi-trash" />
                  </div>
                </div>
              </div>
            })
        }
      </div>
      <div className={`tab-pane fade ${tab === "colors"?"show active":""}`} id="colors" role="tabpanel">
      <div>
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h6 className="mb-0 fw-bold">Color Palettes</h6>
    <button className="btn btn-primary btn-sm" onClick={() => showPopup2("colorModal", sampleColor, function(color){
      saveColor(color)
    })}>+ Add Color</button>
  </div>
  <div className="row g-3">
    {/* Primary Text Color */}
    {
        data.colors.map(function(v, i){
            return    <div className="col-md-6" key={`colors${i}`}>
            <div className="border rounded p-3 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="color-box me-3" style={{backgroundColor: app.getColor(v.styleColor)}} />
                <div>
                  <div className="fw-medium">{v.styleColorName}</div>
                  <div className="text-muted small">{v.styleColor}</div>
                </div>
              </div>
              <div>
                <i className="bi bi-pencil mx-2" onClick={() => showPopup2("colorModal", v, function(color){
      saveColor(color, i)
    })} />
                <i className="bi bi-trash" />
              </div>
            </div>
          </div>
        })
    }
 
    
  </div>
 
 
</div>

      </div>
    </div>
  </div>
</div>

}


const fetchData = async function(data) {
  let response = await fetch("https://snappystaging.appypie.com/webservices/aiEditorService.php", {
    method:"POST",
    body:JSON.stringify(data)
  })
  response = await response.json();
  return response;
}

export default function Themes(props) {
    const [data, setData] = useState([]);
    const [tab, setTab] = useState("");
    useEffect(() => {
      fetchData({
        "method": "getTypographyList"
      }).then(function(response){
        console.log(response);
        setData(response.map(function(v, i){
          if(i === 0) {
            setTab(v.id);
          }
          return v.data;
        }));

        // document.querySelectorAll('#customAccordion .accordion-button').forEach(button => {
        //   button.addEventListener('click', () => {
            
        //     const accordionItem = button.closest('.accordion-item');
        //     const collapse = accordionItem.querySelector('.accordion-collapse');
      
        //     const isOpen = collapse.classList.contains('show');
        //     console.log(isOpen);
      
        //     // Close all panels
        //     document.querySelectorAll('#customAccordion .accordion-collapse').forEach(c => {
        //       c.classList.remove('show');
        //     });
        //     document.querySelectorAll('#customAccordion .accordion-button').forEach(b => {
        //       b.classList.add('collapsed');
        //     });
      
        //     // Toggle current one
        //     if (!isOpen) {
        //       collapse.classList.add('show');
        //       button.classList.remove('collapsed');
        //     }
        //   });
        // });
      });
       
        
    }, []);

    
    return <div className="container-fluid p-2 w-100 h-100 theme-page" style={{overflowY:"scroll"}}>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" rel="stylesheet" />
   
   <div className="container mt-4">
  <h2 className="mb-4">All Themes     <button className="btn btn-primary btn-lg float-end" onClick={() => showPopup("themeModal")}>+ Add Theme</button>
</h2>
  <div className="accordion" id="customAccordion">
    {
        data.map(function(v){
            return    <div key={v.id} className="accordion-item">
            <h2 className="accordion-header">
              <button className={`accordion-button ${tab === v.id?"":"collapsed"}`} type="button" onClick={() => setTab(tab === v.id?null:v.id)}>
                {v.name}
              </button>
            </h2>
            <div className={`accordion-collapse collapse ${tab === v.id?"show":""}`}>
              <div className="accordion-body">
                <Theme key={v.id} data={v} />
              </div>
            </div>
          </div>
        })
    }
  </div>
</div>

<div className="modal fade" id="themeModal">
  <div className="modal-dialog">
    <div className="modal-content rounded-4">
      <div className="modal-header">
        <h5 className="modal-title">Add / Update Theme Name</h5>
        <button type="button" className="btn-close" onClick={() => showPopup("themeModal")} />
      </div>
      <div className="modal-body">
        <label className="form-label">Theme Name</label>
        <input type="text" className="form-control mb-3" placeholder="Enter Theme Name" />
      </div>
      <div className="modal-footer">
        <button className="btn btn-light btn-lg" onClick={() => showPopup("themeModal")}>Cancel</button>
        <button className="btn btn-primary btn-lg" onClick={function(){
            if(document.querySelector("#themeModal").querySelector("input").value.trim() === "") {
                alert("Please add theme name");
                return false;
            }
            fetchData({
                method:"saveTypography",
                data:{
                  name:document.querySelector("#themeModal").querySelector("input").value.trim(),
                  styles:[JSON.parse(JSON.stringify(sampleStyle))],
                  colors:[JSON.parse(JSON.stringify(sampleColor))]
                }
            }).then(function(){
              window.location.reload();
            })
            showPopup("themeModal");
        }}>Add</button>
      </div>
    </div>
  </div>
</div>


    </div>
}